import queryString from 'query-string';
import {
  loopbackGet,
  loopbackPost,
} from '..';
import { BACKEND_URL } from '../../environment';

import {
  DomainAccess,
  DomainAccessReq,
  Trial,
  Survey,
  ExtendedDigitalSurvey,
} from '../../redux/types';

export const backendUrl = BACKEND_URL;

/**
* Returns true if the trial has any approved certificate
*
* @param {number} trialId
*/
export const hasApprovedCertificate = (trialId: number): Promise<{ result: boolean }> => {
  const uri = `Enrollments/hasApprovedCertificate?trialId=${trialId}`;
  return loopbackGet(uri);
};

/**
* Check if email exists in the database
*
* @param {string} email
* @returns {Promise<boolean>} true if exists, false otherwise
*/
export const emailExists = (email: string): Promise<boolean> => {
  const uri = 'QuipUsers/emailExists';
  return loopbackPost(uri, email).then(({ result }: {result: boolean}) => result)
    .catch((e: Error) => {
      console.error(e);
    });
};

export type PrintOptions = {
  orientation: string;
  answerOnly: boolean;
  landscape: boolean;
  breakSection: boolean;
}
export const getPrintBulkSubmissionsUrl = (
  trialId: number, locale: string, token: string, settings: PrintOptions,
): string => {
  const queryParams = queryString.stringify(settings);
  return `${backendUrl}/Trials/${trialId}/printSubmissions?locale=${locale}&${queryParams}&access_token=${token}`;
};

export const addToDomainAccess = async (
  domainAccessData: DomainAccessReq[],
): Promise<DomainAccess[]> => {
  const uri = '/DomainAccesses';
  return loopbackPost(uri, domainAccessData);
};

type TrialWithSurvey = Trial & {
  survey?: Survey;
  digitalSurveys?: ExtendedDigitalSurvey[];
};
export const resolvePublicLinks = (token: string): Promise<TrialWithSurvey> => loopbackGet(`publiclinks/resolve?token=${token}`);
